/* ============
 * Chart Of Accounts Module State
 * ============
 */

export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/chartOfAccounts/state.js